import { getNumberOptionsSelected } from "utils";

const getNumberRowsCompleted = (rows = []) => {
  return rows.filter((currRow) => {
    return getNumberOptionsSelected(currRow.options) > 0;
  }).length;
};

export default getNumberRowsCompleted;
